import React from 'react';
import { NO, YES } from '../../../constants/strings';

import ActionButton from './ActionButton';

const ActionButtons = ({ onConfirm, onClose, onConfirmText, onCloseText }) => (
  <>
    <ActionButton key="yes" onClick={onConfirm}>
      {onConfirmText || YES}
    </ActionButton>
    <ActionButton key="no" onClick={onClose}>
      {onCloseText || NO}
    </ActionButton>
  </>
);

export default ActionButtons;
